import { images } from './images';

export interface GalleryImage {
  src: string;
  alt: string;
}

export const galleryImages: GalleryImage[] = [
  { src: images.extrusionLine, alt: 'Five layer blown film extrusion line at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.paperCores, alt: 'Paper core production at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.stretchFilm, alt: 'Stretch film rolls ready for dispatch at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.palletWrap, alt: 'Stretch wrapped pallets in the warehouse at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.shrinkFilm, alt: 'POF shrink film rolls at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.flutingPaper, alt: 'Fluting paper reels and corrugated board at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.shrinkMachine, alt: 'Shrink wrap machine with tunnel at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.strapping, alt: 'Strapping, buckles and caution tape at Universal Packaging Industries, Umm Al Quwain' },
  { src: images.labelsSleeves, alt: 'PVC sleeves and OPP labels at Universal Packaging Industries, Umm Al Quwain' },
];
